exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fab-main-button{background-color:#82ab2b}.fab-create-address-book-button:after,.fab-invoice-button:after,.fab-payment-button:after{font-family:ProximaNova,arial,helvetica,Verdana,sans-serif;font-weight:400;background:hsla(0,0%,40%,.8);color:#fff}.fab-create-address-book-button{background-color:#a266a2}.fab-invoice-button{background-color:#1e88e5}.fab-payment-button{background-color:#fb3}.fab-icon{height:20px;width:20px;left:calc(50% - 10px);top:calc(50% - 10px)}", ""]);

// exports
